module.exports = __webpack_public_path__ + "static/media/alexander.083bd9ff.jpg";